import React from 'react';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import ApplicationActions from 'Components/ApplicationActions';
import FilePicker from 'Components/FilePicker';

export default class LoadAdditionalDocuments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: props.boat.additionalFiles ? [...props.boat.additionalFiles] : [],
    };

    this.filesIdsToDelete = [];
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.boat.additionalFiles) {
      if (nextProps.boat.additionalFiles > this.state.files.length + this.filesIdsToDelete.length) {
        this.setState({ files: { ...nextProps.boat.additionalFiles } });
      }
    }
    return true;
  }

  handleFileSelect = files => {
    const { markStepAsRedacted } = this.props;

    markStepAsRedacted();

    this.setState(prevState => ({
      files: [...prevState.files, ...files],
    }));
  };

  handleRemoveFile = index => () => {
    const { files } = this.state;
    const { markStepAsRedacted } = this.props;

    markStepAsRedacted();

    if (files[index].created) {
      this.filesIdsToDelete.push(files[index].id);
    }

    this.setState(prevState => {
      prevState.files.splice(index, 1);
      return { files: prevState.files };
    });
  };

  saveAdditionalFiles = () => {
    const { files } = this.state;
    const { boat } = this.props;

    return new Promise((resolve, reject) => {
      if (files.length) {
        const data = new FormData();
        files.filter(file => !file.created).forEach(file => data.append('reports', file));
        http
          .post(boatAPI.uploadAdditionalDocs(boat.id), data)
          .then(() => {
            http.get(boatAPI.getAdditionalDocs(boat.id)).then(({ data }) => {
              this.setState({ files: data }, resolve);
            });
          })
          .catch(() => {
            this.setState({ files: boat.additionalFiles }, () => {
              reject();
            });
          });
      } else {
        resolve();
      }
    });
  };

  deleteAdditionalFiles = () => {
    const { files } = this.state;
    const { boat } = this.props;

    return new Promise((resolve, reject) => {
      if (this.filesIdsToDelete.length) {
        http
          .put(boatAPI.deleteAdditionalDocs(boat.id), this.filesIdsToDelete)
          .then(() => {
            this.filesIdsToDelete.forEach(fileId => {
              const deletedFileIndex = files.findIndex(file => file.id === fileId);
              files.splice(deletedFileIndex, 1);
            });
            this.filesIdsToDelete = [];
            resolve();
          })
          .catch(() => {
            this.filesIdsToDelete = [];
            this.setState({ files: boat.additionalFiles });
            reject();
          });
      } else {
        resolve();
      }
    });
  };

  saveData = () => {
    const { updateBoatDetails } = this.props;

    return new Promise((resolve, reject) => {
      this.saveAdditionalFiles()
        .then(() => {
          return this.deleteAdditionalFiles();
        })
        .then(() => {
          updateBoatDetails({ additionalFiles: this.state.files });
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };

  handleMoveToNextStep = () => {
    const { goToStep } = this.props;

    this.saveData().then(() => {
      goToStep('next', true);
    });
  };

  handleMoveToArbitraryStep = stepId => {
    const { goToStep, stepIsChanged } = this.props;
    if (!stepIsChanged) {
      return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
    }

    this.saveData()
      .then(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
      })
      .catch(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', false);
      });
  };

  render() {
    const { getNavBar, getHeader, stepIsChanged, boat } = this.props;
    const { files } = this.state;

    return (
      <React.Fragment>
        {getHeader(this.saveData)}
        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}
        <section className='scene_section'>
          <FilePicker
            mainWrapperClassName='_box-sizing_border-box'
            handleFileSelect={this.handleFileSelect}
            handleRemoveFile={this.handleRemoveFile}
            files={files}
            httpParams={{ currentMethod: boatAPI.downloadFile, currentId: boat.id }}
            editableStateSectionHeader='Upload Additional Documents'
            uploadButtonText='Upload file'
          />
        </section>
        <ApplicationActions
          backButtonLabel='Prev. Step'
          saveButtonLabel='Next Step'
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/LoadAdditionalDocuments.jsx